export class DeffinumSayneteData {
  themeBackgroundImgUrl: string;
  actions: Action[];
  constructor(rawValue: DeffinumSayneteData) {
    this.themeBackgroundImgUrl = rawValue.themeBackgroundImgUrl;
    this.actions = (rawValue.actions || []).map(a => new Action(a));
  }
}

export class Suggestion {
  id: number;
  label: string;

  constructor(rawValue: Suggestion) {
    this.id = rawValue.id;
    this.label = rawValue.label;
  }
}

export class Action {
  id: number;
  label: string;
  explanation: string;
  url: string;
  positionX: number;
  positionY: number;
  width: number;
  suggestions: Suggestion[] = [];

  suggestionId: number[];

  isValid: null | boolean;

  selectedSuggestionId: number[];

  constructor(rawValue: Action) {
    this.id = rawValue.id;
    this.label = rawValue.label;
    this.explanation = rawValue.explanation;
    this.url = rawValue.url;
    this.suggestionId = rawValue.suggestionId.map(id => id);
    this.selectedSuggestionId = rawValue.selectedSuggestionId.map(id => id);
    this.positionX = rawValue.positionX;
    this.positionY = rawValue.positionY;
    this.width = rawValue.width;
    this.isValid = rawValue.isValid ?? null;
    this.suggestions = (rawValue.suggestions || []).map(s => new Suggestion(s));
  }
}
